export default __webpack_public_path__ + "static/Catherine Natt-2e921748efe57927d7bd4b5cfb6d5e98.webp";